import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import { getTrans as t } from "../../../../Localization/translations";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import ACHaccountsServices from "../../../../services/ACHaccounts/ACHaccountsServices";

function EditAchAccount({id,hideShowachId, setHideShowAchEdit}) {
  // const { id } = useParams();
  const navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();

  // States
  const [party, setParty] = useState(id);
  const [account_name, setAccountName] = useState("");
  const [aba_transit_number, setAbaRoutingNumber] = useState("");
  const [account_number, setAccountNumber] = useState("");
  const [end_date, setAuthorizationExpirationDate] = useState("");
  const [authorization_received, setAuthorizationReceived] = useState("");
  const [one_time_use_only, setOneTimeUseOnly] = useState("");
  const [active_yn, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [is_default, setIsDefault] = useState(false);

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();

  // Fetch ACH Account details for editing
  useEffect(() => {
    setLoading(true);
    ACHaccountsServices.getAchAccount(hideShowachId)
      .then((data) => {
        console.log("Fetched ACH Account data:", data);
        setParty(data.data.details.party || id);
        setAccountName(data.data.details.account_name || "");
        setAbaRoutingNumber(data.data.details.aba_transit_number || "");
        setAccountNumber(data.data.details.account_number || "");
        setAuthorizationExpirationDate(data.data.details.end_date || "");
        setAuthorizationReceived(data.data.details.authorization_received || "");
        setOneTimeUseOnly(data.data.details.one_time_use_only || "");
        setStatus(data.data.details.active_yn || "");
        setIsDefault(data.data.details.is_default || false);

        // Set form values for react-hook-form
        setValue("account_name", data.data.details.account_name || "");
        setValue("aba_transit_number", data.data.details.aba_transit_number || "");
        setValue("account_number", data.data.details.account_number || "");
        setValue("end_date", data.data.details.end_date || "");
        setValue("authorization_received", data.data.details.authorization_received || "");
        setValue("one_time_use_only", data.data.details.one_time_use_only || "");
        setValue("active_yn", data.data.details.active_yn || "");
        setValue("is_default", data.data.details.is_default || false);

      })
      .catch(() => {
        toast.error("Failed to fetch ACH Account details");
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [hideShowachId, setValue]);

  const handleCancel = () => {
    // navigate("/achaccounts");
    setHideShowAchEdit(false);

  };

  // Submit handler using ACHaccountsServices
  const handleUpdate = () => {
    setLoading(true);
    setDisable(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      const payload = {
        party,
        account_name,
        aba_transit_number,
        account_number,
        end_date,
        authorization_received,
        one_time_use_only,
        active_yn,
        is_default
      };

      ACHaccountsServices.editAchAccount(hideShowachId, payload)
        .then((response) => {
          if (response.data.success === 1) {
            toast.success("ACH Account updated successfully", {
              position: "top-right",
              autoClose: 1000,
            });
            setTimeout(() => {
              // navigate("/achaccounts");
                setHideShowAchEdit(false)

            }, 1000);
          } else {
            toast.error(response.data.error || "Failed to update ACH Account");
          }
        })
        .catch(() => {
          toast.error("Failed to update ACH Account");
        })
        .finally(() => {
          setLoading(false);
          setDisable(false);
        });
    } else {
      setLoading(false);
      setDisable(false);
    }
  };

  return (
    <div className="container-fluid">
      <ToastContainer />
      <div className="header">
        <h4 className="mb-3 pt-5 tc">
          <i className="fa fa-solid"></i> {t("Edit ACH Details")}
        </h4>
      </div>
      <div className="card" role="document">
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Form
                role="form text-left"
                onSubmit={handleSubmit(handleUpdate)}
                ref={form}
                action="."
                method="POST"
                id="editAchAccountForm"
              >
                <>
                  <div className="form-group row">
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        Account Name{" "}
                        <Tooltip content="Enter the ACH Account Name.">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        value={account_name}
                        className={`form-control${errors.account_name ? " is-invalid" : ""}`}
                        type="text"
                        name="account_name"
                        id="id_account_name"
                        {...register("account_name", {
                          onChange: (e) => setAccountName(e.target.value),
                          required: true
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors.account_name?.type === 'required' && "Account Name is required"}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        ABA Routing Number{" "}
                        <Tooltip content="Enter the 9-digit ABA Routing Number.">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        value={aba_transit_number}
                        className={`form-control${errors.aba_transit_number ? " is-invalid" : ""}`}
                        type="text"
                        name="aba_transit_number"
                        id="id_aba_transit_number"
                        maxLength={9}
                        {...register("aba_transit_number", {
                          onChange: (e) => setAbaRoutingNumber(e.target.value),
                          required: true,
                          pattern: {
                            value: /^[0-9]{9}$/,
                            message: "Enter a valid 9-digit ABA Routing Number"
                          }
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors.aba_transit_number?.type === 'required' && "ABA Routing Number is required"}
                        {errors.aba_transit_number?.type === 'pattern' && errors.aba_transit_number.message}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        Account Number{" "}
                        <Tooltip content="Enter the Bank Account Number.">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        value={account_number}
                        className={`form-control${errors.account_number ? " is-invalid" : ""}`}
                        type="text"
                        name="account_number"
                        id="id_account_number"
                        {...register("account_number", {
                          onChange: (e) => setAccountNumber(e.target.value),
                          required: true
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors.account_number?.type === 'required' && "Account Number is required"}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        Authorization Expiration Date{" "}
                        <Tooltip content="Date when ACH authorization expires.">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        value={end_date}
                        className={`form-control${errors.end_date ? " is-invalid" : ""}`}
                        type="date"
                        name="end_date"
                        id="id_end_date"
                        {...register("end_date", {
                          onChange: (e) => setAuthorizationExpirationDate(e.target.value),
                          required: true
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors.end_date?.type === 'required' && "Expiration Date is required"}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        Authorization Received{" "}
                        <Tooltip content="Select if Authorization is Received.">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        {...register("authorization_received", { required: true })}
                        onChange={e => {
                          setAuthorizationReceived(e.target.value);
                          setValue("authorization_received", e.target.value);
                        }}
                        value={authorization_received}
                        className={`form-control form-select${errors.authorization_received ? " is-invalid" : ""}`}
                        name="authorization_received"
                        id="authorization_received"
                      >
                        <option value="">{t('Select')}</option>
                        <option value="Y">{t('Yes')}</option>
                        <option value="N">{t('No')}</option>
                      </select>
                      <div className="invalid-feedback">
                        {errors.authorization_received?.type === 'required' && "Authorization Received is required"}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        One Time Use Only{" "}
                        <Tooltip content="Is this account for one-time use only?">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        {...register("one_time_use_only", { required: true })}
                        onChange={e => {
                          setOneTimeUseOnly(e.target.value);
                          setValue("one_time_use_only", e.target.value);
                        }}
                        value={one_time_use_only}
                        className={`form-control form-select${errors.one_time_use_only ? " is-invalid" : ""}`}
                        name="one_time_use_only"
                        id="one_time_use_only"
                      >
                        <option value="">{t('Select')}</option>
                        <option value="Y">{t('Yes')}</option>
                        <option value="N">{t('No')}</option>
                      </select>
                      <div className="invalid-feedback">
                        {errors.one_time_use_only?.type === 'required' && "One Time Use Only is required"}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <label className="col-form-label required">
                        Status{" "}
                        <Tooltip content="Is this ACH Account active?">
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <select
                        {...register("active_yn", { required: true })}
                        onChange={e => {
                          setStatus(e.target.value);
                          setValue("active_yn", e.target.value);
                        }}
                        value={active_yn}
                        className={`form-control form-select${errors.active_yn ? " is-invalid" : ""}`}
                        name="active_yn"
                        id="active_yn"
                      >
                        <option value="">{t('Select')}</option>
                        <option value="Y">{t('Active')}</option>
                        <option value="N">{t('Inactive')}</option>
                      </select>
                      <div className="invalid-feedback">
                        {errors.active_yn?.type === 'required' && "Status is required"}
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <label className="col-form-label">
                      Set as Default{" "}
                      <Tooltip content="Mark this account as the default ACH account for the party.">
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="is_default"
                        name="is_default"
                        checked={is_default}
                        {...register("is_default", {
                          onChange: (e) => setIsDefault(e.target.checked)
                        })}
                      />
                      <label className="form-check-label" htmlFor="is_default">
                        Default Account
                      </label>
                    </div>
                  </div>
                
                  <div className="text-left py-3">
                    <button
                      type="button"
                      className="btn btn-secondary btn-md"
                      onClick={handleCancel}
                      disabled={disable}
                    >
                      {t('Cancel')}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="submit"
                      disabled={disable}
                      className="border-0 btn btn-primary btn-gradient-primary btn-md"
                    >
                      {loading === false ? t('Update') : <ButtonLoading />}
                    </button>
                  </div>
                </>
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditAchAccount;